import { useParams } from 'react-router-dom';
import StandardsCatalog from '../../features/standards/layouts/catalog';
import StandardDetail from '../../features/standards/layouts/detail';
import StandardVersion from '../../features/standards/layouts/version';
import '../../features/standards/styles/standards.css';

export default function StandardsPage({ create = false }) {
    const { standardId, versionId } = useParams();
    if (versionId) return <StandardVersion key={versionId} standardId={standardId} versionId={versionId} />;
    if (standardId) return <StandardDetail key={standardId} id={standardId} />;
    return <StandardsCatalog create={create} />;
}
